import { render, staticRenderFns } from "./NarasuSpringCampaign2022.vue?vue&type=template&id=88647e0e&scoped=true&"
import script from "./NarasuSpringCampaign2022.vue?vue&type=script&lang=js&"
export * from "./NarasuSpringCampaign2022.vue?vue&type=script&lang=js&"
import style0 from "./NarasuSpringCampaign2022.vue?vue&type=style&index=0&id=88647e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88647e0e",
  null
  
)

export default component.exports